var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ReportNav", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var projectInfo = ref.projectInfo
          var reportInfo = ref.reportInfo
          return [
            _c(
              "div",
              { staticClass: "general-container" },
              [
                _c("div", { staticClass: "info" }, [
                  _c("div", { staticClass: "rated" }, [
                    _c("span", { staticClass: "rated-text" }, [_vm._v("评级")]),
                    _c("span", { staticClass: "rated-result" }, [
                      _vm._v(_vm._s(_vm.score)),
                    ]),
                  ]),
                  _c("div", { staticClass: "base-info" }, [
                    _c("div", { staticClass: "base-info-top" }, [
                      _c("p", [
                        _vm._v("项目名称: " + _vm._s(projectInfo.game_name)),
                      ]),
                      _c("p", [
                        _vm._v(
                          "测试时间: " +
                            _vm._s(_vm.parseTime(reportInfo.created_at))
                        ),
                      ]),
                    ]),
                    _c("p", [
                      _vm._v("测试机型: " + _vm._s(reportInfo.device_info)),
                    ]),
                    _c("p", [
                      _vm._v(
                        "测试总帧数: " + _vm._s(_vm.pageConfig.totalFrame)
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "compare" },
                    [
                      _c("el-button", { on: { click: _vm.gotoCompare } }, [
                        _vm._v("报告对比"),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "statistics" }, [
                  _c("div", { staticClass: "left" }, [
                    _c("div", { staticClass: "issue" }, [
                      _c("span", { staticClass: "issue-text" }, [
                        _vm._v("可优化问题"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "issue-num",
                          on: { click: _vm.drawerShow },
                        },
                        [_vm._v(_vm._s(_vm.pageConfig.optimize.length))]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "right" }, [
                    _c(
                      "div",
                      { staticClass: "statistics-item summary-wrapper" },
                      _vm._l(_vm.pageConfig.info, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "summary",
                            class: {
                              danger:
                                item.advice &&
                                (item.advice.symbol == "lt"
                                  ? item.advice.data[_vm.reportDevice][
                                      item.advice.data.length - 1
                                    ] > item.value
                                  : item.advice.data[_vm.reportDevice][
                                      item.advice.data.length - 1
                                    ] < item.value),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "summary-title" },
                              [
                                _c("span", [_vm._v(_vm._s(item.title))]),
                                item.help
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "rule-tip-content",
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "rule-tip-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.help[item.help].title
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "rule-tip-recommend",
                                              },
                                              [
                                                _vm._v("建议值"),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.advice.symbol ===
                                                        "lt"
                                                        ? ">"
                                                        : "<"
                                                    ) +
                                                      _vm._s(
                                                        item.advice.data[
                                                          _vm.reportDevice
                                                        ][
                                                          item.advice.data
                                                            .length - 1
                                                        ]
                                                      ) +
                                                      _vm._s(
                                                        _vm.help[item.help].unit
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "rule-tip-suggestion",
                                              },
                                              [_vm._v("优化建议")]
                                            ),
                                            _vm._l(
                                              _vm.help[
                                                item.help
                                              ].optimize.split("\r\n"),
                                              function (tip, tipsIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      item.help +
                                                      "-" +
                                                      tipsIndex,
                                                    staticClass: "rule-tip-p",
                                                  },
                                                  [_vm._v(_vm._s(tip))]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "summary-value" }, [
                              _vm._v(_vm._s(item.value)),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _c(
                  "el-collapse",
                  {
                    staticClass: "tablist",
                    model: {
                      value: _vm.activeNames,
                      callback: function ($$v) {
                        _vm.activeNames = $$v
                      },
                      expression: "activeNames",
                    },
                  },
                  _vm._l(_vm.pageConfig.chartInfo, function (item, index) {
                    return _c(
                      "el-collapse-item",
                      { key: index, attrs: { name: index + "" } },
                      [
                        _c("template", { slot: "title" }, [
                          _c("div", { staticClass: "chart-title-wrapper" }, [
                            _c("i", { staticClass: "chart-title-tag" }),
                            _c(
                              "div",
                              { staticClass: "chart-title" },
                              [
                                _c("span", [_vm._v(_vm._s(item.title))]),
                                item.help && _vm.help[item.help]
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "rule-tip-content",
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "rule-tip-suggestion",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.help[item.help].title
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._l(
                                              _vm.help[item.help].desc.split(
                                                "\r\n"
                                              ),
                                              function (tip, tipsIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      item.help +
                                                      "-" +
                                                      tipsIndex,
                                                    staticClass: "rule-tip-p",
                                                  },
                                                  [_vm._v(_vm._s(tip))]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          [
                            _c("line-chart", {
                              staticClass: "line-chart",
                              attrs: { id: item.id, "chart-data": item.data },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-drawer",
              {
                staticClass: "drawer-box",
                attrs: {
                  title: "优化信息",
                  visible: _vm.drawer,
                  direction: "rtl",
                  "before-close": _vm.drawerClose,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.drawer = $event
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "drawer-main" },
                  [
                    _c(
                      "el-collapse",
                      {
                        model: {
                          value: _vm.activeNamesDrawer,
                          callback: function ($$v) {
                            _vm.activeNamesDrawer = $$v
                          },
                          expression: "activeNamesDrawer",
                        },
                      },
                      _vm._l(_vm.pageConfig.optimize, function (item) {
                        return _c(
                          "el-collapse-item",
                          { key: item.help, attrs: { name: item.help } },
                          [
                            _c("template", { slot: "title" }, [
                              _c(
                                "div",
                                { staticClass: "chart-title-wrapper" },
                                [
                                  _c("div", { staticClass: "chart-title" }, [
                                    _c("span", [_vm._v(_vm._s(item.title))]),
                                  ]),
                                ]
                              ),
                            ]),
                            _c(
                              "dd",
                              { staticClass: "rule-tip-content" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "rule-tip-recommend" },
                                  [
                                    _vm._v("建议值"),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.advice.symbol === "lt"
                                            ? ">"
                                            : "<"
                                        ) +
                                          _vm._s(
                                            item.advice.data[_vm.reportDevice][
                                              item.advice.data.length - 1
                                            ]
                                          ) +
                                          _vm._s(_vm.help[item.help].unit)
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "rule-tip-suggestion" },
                                  [_vm._v("优化建议")]
                                ),
                                _vm._l(
                                  _vm.help[item.help].optimize.split("\r\n"),
                                  function (tip, tipsIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.help + "-" + tipsIndex,
                                        staticClass: "rule-tip-p",
                                      },
                                      [_vm._v(_vm._s(tip))]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          2
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }